"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var combineLearningPanelFreeUrl_1 = __importDefault(require("./combineLearningPanelFreeUrl"));
var rest_1 = __importDefault(require("../../../rest"));
var courseDisplayNames_1 = __importDefault(require("../../mock/courseDisplayNames"));
var CoursesAPIs = {
    getCourseDisplayNames: function () {
        return rest_1.default.get({
            mockFunc: function () { return courseDisplayNames_1.default; },
            url: (0, combineLearningPanelFreeUrl_1.default)('/courses/course-display-names'),
        });
    },
};
exports.default = CoursesAPIs;
